<h1 class="error-code">
    503
</h1>
<p class="error-text">
    We're temporarily unavailable.
</p>
<p class="error-sub">
    Our servers are currently down for maintenance or are overloaded.
</p>
<p class="error-sub">
    Please try again in a few minutes.
</p>
<button mat-raised-button color="primary" (click)="goHome()"
        class="frmg-primary-button">
    Try Again
</button>